module.exports = __webpack_public_path__ + "img/buddy_nose-03.1b44e08a.svg";